export { default } from './P18PriceInfo';
